/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, {
    Suspense, useMemo, useReducer, useRef,
} from 'react';

import LINKS from 'app/const/links';
import Link from 'app/components/Link';
import { useDynamicSetPrice } from 'app/components/SetsMobileSlider/ABSets5Dishes/hooks/useDynamicSetPrice';
import { cardLinkDataMap } from 'app/components/SetsMobileSlider/sets.record';
import classNames from 'classnames';
import { analyticService } from 'global/services';
import { useReactiveVar } from '@apollo/client';
import { isAsNewbieAuthedVar } from 'app/apollo/reaction';
import { Badge, OrdinaryLink } from '../MobileSiteNavOrdinaryLinks/MobileSiteNavOrdinaryLink';
import { BurgerMenuReducer, initialBurgerMenuState } from './burgerMenuV2.store';
import { forSpecialOccasionsLinks, getAboutServiceLinks } from './linkv2.record';
import { BurgerMenuCardFrame } from './layout';

// IMGS
import arrowIconPath from './img/arrow.img.svg';
import callIconPath from './img/callIcon.img.svg';
import tgIconPath from './img/tgIcon.img.svg';
import vkIconPath from './img/vkIcon.img.svg';
import maxIconPath from './img/max_burger.img.svg';
import ToProfileIconPath from './img/profile.img.svg';
import LoginIconPath from './img/deliveries.img.svg';
// STYLES
import css from './burgerMenuV2.module.scss';
import { useBurgerMenuBanner } from './useDynamicBanner';

const { SPA_MENU, TRIAL_FIRST_ORDER_SET_UPPER_PRICES } = LINKS;

const ToProfileIcon = () => (
    <div className={css.burgerLoginRowIconFrame}>
        <img src={ToProfileIconPath} alt="toProfel" className={css.burgerLoginRowIconItem} />
    </div>
);

const LoginIcon = () => (
    <div className={css.burgerLoginRowIconFrame}>
        <img src={LoginIconPath} alt="login" className={css.burgerLoginRowIconItem} />
    </div>
);

interface ILoginRowProps {
    isAuthed: boolean
    onClickLogin: () => void
    locale: string
}

const LoginRowText = {
    ru: {
        deliveryTitle: 'Мои доставки',
        loginTitle: 'Войти',
    },
    en: {
        deliveryTitle: 'My deliveries',
        loginTitle: 'Login',
    },
};


const LoginRow = (props: ILoginRowProps) => {
    const { isAuthed, onClickLogin, locale } = props;
    const isAsNewbieAuthed = useReactiveVar(isAsNewbieAuthedVar);

    const { icon, text } = useMemo(() => ({
        icon: isAuthed || isAsNewbieAuthed
            ? <LoginIcon />
            : <ToProfileIcon />,
        text: isAuthed || isAsNewbieAuthed
            // @ts-ignore
            ? LoginRowText[locale].deliveryTitle
            // @ts-ignore
            : LoginRowText[locale].loginTitle,
    }), [isAuthed, isAsNewbieAuthed, locale]);

    return (
        <BurgerMenuCardFrame>
            <button
                type="button"
                onClick={(event) => {
                    if (isAuthed) {
                        analyticService.push({
                            eventName: 'Burger_Menu_Click',
                            button_name: 'Deliveries',
                            source_name: 'burger_menu',
                        });
                    }
                    // @ts-expect-error
                    onClickLogin(event);
                }}
                className={css.burgerLoginRowRoot}
            >

                <div className={css.burgerLoginRowIcon}>
                    {icon}
                </div>
                <div className={css.burgerLoginRowText}>
                    {text}
                </div>
            </button>
        </BurgerMenuCardFrame>
    );
};

interface ISetBannerRowProps {
    isNewbie: boolean
}

const SetBannerRow = (props: ISetBannerRowProps) => {
    const { isNewbie } = props;
    const { name, href } = useBurgerMenuBanner();

    const bannerClasses = classNames({
        [css.setBannerRowBackground]: true,
        [css[name]]: true,
    });

    // if (!isNewbie) {
    //     return (
    //         <BurgerMenuCardFrame>
    //             <Link
    //                 href={href}
    //                 className={css.setBannerRowRoot}
    //                 onClick={() => {
    //                     analyticService.push({
    //                         eventName: 'Burger_Menu_Click',
    //                         button_name: 'Banner',
    //                         source_name: 'burger_menu',
    //                     });
    //                 }}
    //             >
    //                 <div className={bannerClasses} />
    //             </Link>
    //         </BurgerMenuCardFrame>
    //     );
    // }

    // if (isNewbie) {
    //     return (
    //         <BurgerMenuCardFrame>

    //             <Link
    //                 href={TRIAL_FIRST_ORDER_SET_UPPER_PRICES.hrefBasket}
    //                 className={css.setBannerRowRoot}
    //             >
    //                 <div className={css.setBannerRowBackground} />
    //             </Link>
    //         </BurgerMenuCardFrame>
    //     );
    // }

    return (
        <BurgerMenuCardFrame>
            <Link
                href={href}
                className={css.setBannerRowRoot}
                onClick={() => {
                    analyticService.push({
                        eventName: 'Burger_Menu_Click',
                        button_name: 'Banner',
                        source_name: 'burger_menu',
                    });
                }}
            >
                <div className={bannerClasses} />
            </Link>
        </BurgerMenuCardFrame>
    );
};

const FiveSetRow = (props: any) => {
    const { setTypeVar, cardKey, locale } = props;

    const isEng = locale === 'en';

    const title = {
        EVERYDAY_SET: isEng ? 'Beneficial' : 'Выгодный',
        PREMIUM_SET_GREEN_VERSION: isEng ? 'Green. Light ingredients' : 'Green. Лёгкие ингредиенты',
        OUR_SET: isEng ? 'Top 5 Best Dishes' : 'Топ 5 лучших блюд',
    };

    const { hasDishesInSet } = useDynamicSetPrice(setTypeVar);

    if (!hasDishesInSet) {
        return null;
    }

    return (
        <div
            className={css.foldingMenuListItem}
        >
            {/* @ts-ignore */}
            <OrdinaryLink {...props} title={title[cardKey]} />
        </div>
    );
};

const FiveSetRowFallback = (props: any) => {
    const { cardKey, locale } = props;

    const isEng = locale === 'en';

    const title = {
        EVERYDAY_SET: isEng ? 'Beneficial' : 'Выгодный',
        PREMIUM_SET_GREEN_VERSION: isEng ? 'Green. Light ingredients' : 'Green. Лёгкие ингредиенты',
        OUR_SET: isEng ? 'Top 5 Best Dishes' : 'Топ 5 лучших блюд',
    };

    // @ts-ignore
    const text = title[cardKey];

    return (
        <div
            className={css.foldingMenuListItem}
        >
            {text}
        </div>
    );
};

interface IFoldingMenuRow {
    locale?: string
    //  eslint-disable-next-line no-unused-vars
    onClickNavLink?: (e: MouseEvent) => void
    isSetRowOpen: boolean,
    isSpecialRowOpen: boolean
    dispatch: any
}

const indexPageLink = {
    titleTrKey: 'Главная',
    href: '/',
    handler: () => { },
    type: 'link',
    id: 'indexPageLink',
};

const foldingMenuRowText = {
    ru: {
        rowTitle: 'Сеты 5 блюд',
        rowSpecialTitle: 'Для особых случаев',
        rowAboutTitle: 'О сервисе',
    },
    en: {
        rowTitle: 'Set of 5 dishes',
        rowSpecialTitle: 'For special occasions',
        rowAboutTitle: 'About the service',
    },
};

const christmasLink = {
    id: 'Mealprep',
    data: {
        title: 'Рождество',
        href: '/christmas',
        handler: () => { },
        type: 'link',
        trackId: 'Mealprep',
    },
};

const mealprepLink = {
    id: 'Mealprep',
    data: {
        title: 'Баланс-бокс на неделю',
        href: '/mealprep',
        handler: () => { },
        type: 'link',
        trackId: 'Mealprep',
    },
};

const FoldingMenuRow = ({
    onClickNavLink = () => { },
    locale = 'ru',
    isSetRowOpen = false,
    isSpecialRowOpen = false,
    dispatch = () => { },
}: IFoldingMenuRow) => {
    /* SELECTORS */
    const iconTwoState = useMemo(
        () => (isSetRowOpen ? 'open' : 'close'),
        [isSetRowOpen],
    );

    const iconThreeState = useMemo(
        () => (isSpecialRowOpen ? 'open' : 'close'),
        [isSpecialRowOpen],
    );

    const fiveSetOrder = useMemo(
        () => ['EVERYDAY_SET', 'OUR_SET', 'PREMIUM_SET_GREEN_VERSION'],
        [],
    );

    const specialOccasionsLinks = useMemo(
        () => forSpecialOccasionsLinks({ locale, onClickNavLink }),
        [onClickNavLink, locale],
    );

    const fiveSetLinks = useMemo(
        () => {
            const fiveSetObj = fiveSetOrder.map((key) => {
                const obj = cardLinkDataMap.get(key);
                return {
                    ...obj,
                };
            });
            return fiveSetObj;
        },
        [fiveSetOrder],
    );

    /* STYLES */
    const rowTwoIconClasses = classNames({
        [css.foldingMenuTitleButtonIcon]: true,
        [css[iconTwoState]]: true,
    });

    const rowThreeIconClasses = classNames({
        [css.foldingMenuTitleButtonIcon]: true,
        [css[iconThreeState]]: true,
    });

    const spaLink = {
        titleTrKey: 'mobileNav.menuDishes',
        href: SPA_MENU.href,
        handler: onClickNavLink,
        type: 'navLink',
        id: 'spaLink',
    };

    return (
        <BurgerMenuCardFrame>
            <div className={css.foldingMenuRowRoot}>
                <div className={css.foldingMenuItemsContainer}>
                    <div className={css.foldingMenuDividerWrapper}>
                        <div
                            className={css.foldingMenuTitleButton}
                        >
                            {/* @ts-ignore */}
                            <OrdinaryLink
                                {...indexPageLink}
                                handler={() => {
                                    analyticService.push({
                                        eventName: 'Burger_Menu_Click',
                                        button_name: 'All_dishes',
                                        source_name: 'burger_menu',
                                    });
                                }}
                            />
                            <img
                                src={arrowIconPath}
                                alt="arrow"
                                className={css.foldingMenuTitleButtonIcon}
                                role="none"
                                onClick={() => {
                                    const el = document.querySelector<HTMLElement>(`#${indexPageLink.id}`);
                                    el?.click();
                                }}
                            />
                        </div>
                    </div>
                    <div className={css.foldingMenuDividerWrapper}>
                        <div
                            className={css.foldingMenuTitleButton}
                        >
                            <h1 style={{ display: 'none' }}>Все блюда</h1>
                            {/* @ts-ignore */}
                            <OrdinaryLink
                                {...spaLink}
                                handler={() => {
                                    analyticService.push({
                                        eventName: 'Burger_Menu_Click',
                                        button_name: 'All_dishes',
                                        source_name: 'burger_menu',
                                    });
                                }}
                            />
                            <img
                                src={arrowIconPath}
                                alt="arrow"
                                className={css.foldingMenuTitleButtonIcon}
                                role="none"
                                onClick={() => {
                                    const el = document.querySelector<HTMLElement>(`#${spaLink.id}`);
                                    el?.click();
                                }}
                            />
                        </div>
                    </div>
                    <div className={css.foldingMenuDividerWrapper}>
                        <button
                            className={css.foldingMenuTitleButton}
                            type="button"
                            onClick={() => {
                                dispatch({
                                    type: 'TOGGLE_FOLDING_ROW',
                                    payload: { isSetRowOpen: !isSetRowOpen },
                                });
                                analyticService.push({
                                    eventName: 'Burger_Menu_Click',
                                    button_name: 'Set',
                                    source_name: 'burger_menu',
                                });
                            }}
                        >
                            <div className={css.foldingMenuTitleButtonText}>
                                {/* @ts-ignore */}
                                {foldingMenuRowText[locale].rowTitle}
                            </div>
                            <img
                                src={arrowIconPath}
                                alt="arrow"
                                className={rowTwoIconClasses}
                            />
                        </button>
                        {iconTwoState === 'open' && (
                            <div className={css.foldingMenuList}>
                                {fiveSetLinks.map((item) => (
                                    <div
                                        key={item.trackId}
                                        className={css.foldingMenuListItem}
                                    >
                                        <Suspense fallback={<FiveSetRowFallback {...item} locale={locale} />}>
                                            <FiveSetRow {...item} locale={locale} />
                                        </Suspense>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={css.foldingMenuDividerWrapper}>
                        <OrdinaryLink {...mealprepLink.data} />
                    </div>
                    {/*  Для особых случаев */}
                    <div className={css.foldingMenuDividerWrapper}>
                        <button
                            className={css.foldingMenuTitleButton}
                            type="button"
                            onClick={() => {
                                dispatch({
                                    type: 'TOGGLE_FOLDING_ROW',
                                    payload: { isSpecialRowOpen: !isSpecialRowOpen },
                                });
                                analyticService.push({
                                    eventName: 'Burger_Menu_Click',
                                    button_name: 'Special',
                                    source_name: 'burger_menu',
                                });
                            }}
                        >
                            <div className={css.foldingMenuTitleButtonText}>
                                {/* @ts-ignore */}
                                {foldingMenuRowText[locale].rowSpecialTitle}
                            </div>
                            <img
                                src={arrowIconPath}
                                alt="arrow"
                                className={rowThreeIconClasses}
                            />
                        </button>
                        {iconThreeState === 'open' && (
                            <div className={css.foldingMenuList}>
                                {specialOccasionsLinks.map((item: any) => {
                                    const menuItemStyles = classNames({
                                        [css.foldingMenuListItem]: true,
                                        [css.hasBadge]: Boolean(item.data?.badge),
                                    });
                                    return (
                                        <div
                                            key={item.id}
                                            className={menuItemStyles}
                                        >
                                            {item.data?.badge && (
                                                <div className={css.badgeWrapper}>
                                                    <Badge type={item.data?.badge} />
                                                </div>
                                            )}
                                            {/* @ts-ignore */}
                                            <OrdinaryLink {...item.data} />
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </BurgerMenuCardFrame>
    );
};

interface IAboutRowProps {
    locale?: string
    //  eslint-disable-next-line no-unused-vars
    onClickNavLink?: (e: MouseEvent) => void
    isAboutRowOpen: boolean
    dispatch: any
}

const AboutRow = ({
    locale = 'ru',
    onClickNavLink = () => { },
    isAboutRowOpen = false,
    dispatch = () => { },
}: IAboutRowProps) => {
    /* SELECTORS */

    const aboutServiceLinks = useMemo(
        () => getAboutServiceLinks({ locale, onClickNavLink }),
        [onClickNavLink, locale],
    );

    const iconAboutState = useMemo(
        () => (isAboutRowOpen ? 'open' : 'close'),
        [isAboutRowOpen],
    );

    /* STYLES */

    const rowAboutIconClasses = classNames({
        [css.foldingMenuTitleButtonIcon]: true,
        [css[iconAboutState]]: true,
    });

    /* RENDER */

    return (
        <BurgerMenuCardFrame>
            <div className={css.aboutRowRoot}>
                <button
                    className={css.aboutRowButton}
                    type="button"
                    onClick={() => {
                        dispatch({
                            type: 'TOGGLE_FOLDING_ROW',
                            payload: { isAboutRowOpen: !isAboutRowOpen },
                        });
                        analyticService.push({
                            eventName: 'Burger_Menu_Click',
                            button_name: 'About',
                            source_name: 'burger_menu',
                        });
                    }}
                >
                    <div className={css.aboutRowText}>
                        {/* @ts-ignore */}
                        {foldingMenuRowText[locale].rowAboutTitle}
                    </div>
                    <img
                        src={arrowIconPath}
                        alt="arrow"
                        className={rowAboutIconClasses}
                    />
                </button>
                {iconAboutState === 'open' && (
                    <div className={css.foldingMenuList}>
                        {aboutServiceLinks.map((item) => (
                            <div
                                key={item.id}
                                className={css.foldingMenuListItem}
                            >
                                <OrdinaryLink {...item.data} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </BurgerMenuCardFrame>
    );
};

interface IBurgerMenuV2Props {
    isAuthed?: boolean,
    locale?: string,
    //  eslint-disable-next-line no-unused-vars
    onClickNavLink?: (e: MouseEvent) => void
    onClickLogin?: () => void
    isNewbie?: boolean
}

export function BurgerMenuV2({
    isAuthed = false,
    onClickNavLink = () => { },
    onClickLogin = () => { },
    isNewbie = false,
}: IBurgerMenuV2Props,
) {
    const [burgerMenuState, dispatch] = useReducer(BurgerMenuReducer, initialBurgerMenuState);

    const locale = useMemo<string>(() => {
        const localeValue = sessionStorage.getItem('lang');
        return localeValue || 'ru';
    }, []);

    return (
        <div
            className={css.burgerMenuV2Root}
            aria-label="burger-menu-v2-root"
        >
            <LoginRow
                isAuthed={isAuthed}
                onClickLogin={onClickLogin}
                locale={locale}
            />
            <SetBannerRow
                // onClickNavLink={onClickNavLink}
                isNewbie={isNewbie}
            />
            <FoldingMenuRow
                onClickNavLink={onClickNavLink}
                locale={locale}
                isSetRowOpen={burgerMenuState.isSetRowOpen}
                isSpecialRowOpen={burgerMenuState.isSpecialRowOpen}
                dispatch={dispatch}
            />
            <AboutRow
                onClickNavLink={onClickNavLink}
                locale={locale}
                isAboutRowOpen={burgerMenuState.isAboutRowOpen}
                dispatch={dispatch}
            />
            <div className={css.burgerMenuV2FootRoot} style={{ paddingRight: 0 }}>
                <div className={css.burgerMenuV2TimeOpen}>
                    {locale === 'ru' ? (
                        <>
                            Ежедневно
                            <br />
                            с 6:00 до 23:00
                        </>
                    ) : (

                        <>
                            Daily
                            <br />
                            from 6:00 to 23:00
                        </>
                    )}
                </div>
                <div className={css.burgerFootSocialLinkWrapper}>
                    <a
                        onClick={() => analyticService.push({
                            eventName: 'Burger_Menu_Click',
                            button_name: 'Call',
                            source_name: 'burger_menu',
                        })}
                        href="tel:+78005504612"
                        className={css.burgerFootSocialLinkItem}
                    >
                        <img src={callIconPath} alt="" className="" />
                    </a>
                    <a
                        onClick={() => {
                            analyticService.push({
                                eventName: 'Burger_Menu_Click',
                                button_name: 'VK',
                                source_name: 'burger_menu',
                            });
                        }}
                        href="https://vk.me/elementaree"
                        className={css.burgerFootSocialLinkItem}
                    >
                        <img src={vkIconPath} alt="" className="" />
                    </a>
                    <a
                        onClick={() => analyticService.push({
                            eventName: 'Burger_Menu_Click',
                            button_name: 'TG',
                            source_name: 'burger_menu',
                        })}
                        href="https://t.me/elementaree_bot"
                        className={css.burgerFootSocialLinkItem}
                    >
                        <img src={tgIconPath} alt="" className="" />
                    </a>
                    <a
                        onClick={() => analyticService.push({
                            eventName: 'Burger_Menu_Click',
                            button_name: 'Max',
                            source_name: 'burger_menu',
                        })}
                        href="https://max.ru/id7724417578_bot"
                        className={css.burgerFootSocialLinkItem}
                    >
                        <img src={maxIconPath} alt="" className="" />
                    </a>
                </div>
            </div>
        </div>
    );
}
